export function registerServiceWorker() {
  // Vite PWA plugin with registerType: "autoUpdate" will automatically
  // inject service worker registration code. This function provides
  // additional update handling if needed.
  if ("serviceWorker" in navigator && import.meta.env.PROD) {
    // Wait for any auto-injected registration to complete
    window.addEventListener("load", () => {
      // Check if service worker is already registered
      navigator.serviceWorker.ready.then((registration) => {
        // Service Worker ready

        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // Check every hour

        // Handle updates
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener("statechange", () => {
              if (
                newWorker.state === "installed" &&
                navigator.serviceWorker.controller
              ) {
                // New service worker available
                // New service worker available
              }
            });
          }
        });
      }).catch((error) => {
        console.error("Service Worker error:", error);
      });
    });
  }
}

